import { luscinia } from '../../luscinia';
import { GridApi, GridOptions, createGrid } from 'ag-grid-community';
import { Call } from '../CallPanelTypes';

export class CallGrid {
    public api: GridApi<Call>;
    private readonly containerEl: HTMLElement;

    constructor(containerEl: HTMLElement) {
        this.containerEl = containerEl;
    }

    public async init(): Promise<void> {
        const response = await fetch('/data/calls/getActiveCalls');
        const data: Call[] = await response.json();

        const gridOptions: GridOptions = {
            rowData: data,
            onRowClicked: (params) =>
            {
                luscinia.openCustomModalEdit(`/data/calls`, params.data['id'], '');
            },
            columnDefs: [
                { field: 'number', headerName: 'Number', flex: 1, resizable: false },
                { field: 'priority', headerName: 'Priority', flex: 1, resizable: false },
                { field: 'callStatus', headerName: 'Call Status', flex: 1, resizable: false },
                { field: 'dueDate', headerName: 'Due Date', flex: 1, resizable: false }],
            rowSelection: 'single',
            suppressCellFocus: true,
            suppressRowClickSelection: true,
        };
        this.api = createGrid(this.containerEl, gridOptions);

        const firstDataRender = new Promise<void>((resolve) => {
            this.api.addEventListener('firstDataRendered', () => {
                resolve();
            });
        });
        await firstDataRender;
    }
}
